import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { Factory } from '../bo/factory';
import { Warehouse } from '../bo/warehouse';

@Injectable({
  providedIn: 'root'
})
export class ProductSourcesService {

  constructor(private readonly http: HttpService) { }

  // ========== FACTORIES ==========

  getFactories(orgId: number): Observable<Factory[]> {
    return this.http.get<Factory[]>(`org/${orgId}/factories`);
  }

  getFactory(orgId: number, factoryId: number): Observable<Factory> {
    return this.http.get<Factory>(`org/${orgId}/factories/${factoryId}`);
  }

  createFactory(orgId: number, factory: Partial<Factory>): Observable<Factory> {
    return this.http.post<Partial<Factory>, Factory>(`org/${orgId}/factories`, factory);
  }

  updateFactory(orgId: number, factoryId: number, factory: Partial<Factory>): Observable<Factory> {
    return this.http.put<Partial<Factory>, Factory>(`org/${orgId}/factories/${factoryId}`, factory);
  }

  deleteFactory(orgId: number, factoryId: number): Observable<void> {
    return this.http.delete<void>(`org/${orgId}/factories/${factoryId}`);
  }

  // ========== WAREHOUSES ==========

  getWarehouses(orgId: number): Observable<Warehouse[]> {
    return this.http.get<Warehouse[]>(`org/${orgId}/warehouses`);
  }

  getWarehouse(orgId: number, warehouseId: number): Observable<Warehouse> {
    return this.http.get<Warehouse>(`org/${orgId}/warehouses/${warehouseId}`);
  }

  getWarehousesByFactory(orgId: number, factoryId: number): Observable<Warehouse[]> {
    return this.http.get<Warehouse[]>(`org/${orgId}/warehouses/byFactory/${factoryId}`);
  }

  createWarehouse(orgId: number, warehouse: Partial<Warehouse>): Observable<Warehouse> {
    return this.http.post<Partial<Warehouse>, Warehouse>(`org/${orgId}/warehouses`, warehouse);
  }

  updateWarehouse(orgId: number, warehouseId: number, warehouse: Partial<Warehouse>): Observable<Warehouse> {
    return this.http.put<Partial<Warehouse>, Warehouse>(`org/${orgId}/warehouses/${warehouseId}`, warehouse);
  }

  deleteWarehouse(orgId: number, warehouseId: number): Observable<void> {
    return this.http.delete<void>(`org/${orgId}/warehouses/${warehouseId}`);
  }
}
